
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

interface TooltipAndToastProviderProps {
  children: React.ReactNode;
}

export const TooltipAndToastProvider: React.FC<TooltipAndToastProviderProps> = ({ children }) => {
  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      {children}
    </TooltipProvider>
  );
};

export default TooltipAndToastProvider;
